<template>
  <LayoutNavbar />
  <slot />
  <LayoutFooter />
</template>
